import { render, staticRenderFns } from "./addIncreaseOrDecrease.vue?vue&type=template&id=f91023e4&scoped=true"
import script from "./addIncreaseOrDecrease.vue?vue&type=script&lang=ts"
export * from "./addIncreaseOrDecrease.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91023e4",
  null
  
)

export default component.exports